import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function ReportIcon({ className, width = 23, height = 23 }: IconProps) {
    return (
        <svg
            className={cn('fill-current', className)}
            width={width}
            height={height}
            id='Layer_1'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
            data-name='Layer 1'
        >
            <path d='m17 0h-6c-2.757 0-5 2.243-5 5v10c0 2.757 2.243 5 5 5h6c2.757 0 5-2.243 5-5v-10c0-2.757-2.243-5-5-5zm3 15c0 1.654-1.346 3-3 3h-6c-1.654 0-3-1.346-3-3v-10c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3zm-3 8c0 .553-.448 1-1 1h-9c-2.757 0-5-2.243-5-5v-12c0-.553.448-1 1-1s1 .447 1 1v12c0 1.654 1.346 3 3 3h9c.552 0 1 .447 1 1zm-5-9v1c0 .553-.448 1-1 1s-1-.447-1-1v-1c0-.553.448-1 1-1s1 .447 1 1zm6-1v2c0 .553-.448 1-1 1s-1-.447-1-1v-2c0-.553.448-1 1-1s1 .447 1 1zm-3-1v3c0 .553-.448 1-1 1s-1-.447-1-1v-3c0-.553.448-1 1-1s1 .447 1 1zm3-7v2.303c0 .62-.75.931-1.188.492l-.596-.596-1.509 1.509c-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-.793-.793-.793.793c-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414l1.5-1.5c.391-.391 1.023-.391 1.414 0l.793.793.802-.802-.596-.596c-.438-.438-.128-1.188.492-1.188h2.303c.552 0 1 .448 1 1z' />
        </svg>
    );
}

export default ReportIcon;

